import React from 'react';
import { FaRegClock } from '@react-icons/all-files/fa/FaRegClock';
import EmptyLayout from './Layout/EmptyLayout';
import { useIsEffectivelyOnline } from '@/hooks/useIsEffectivelyOnline';
import { Card, CardContent } from './ui/card';
import { useMaintenanceModeFlag } from '@/utils/analytics/maintenanceFlag';
import { useAuthState } from '@/utils/auth';
import { RoleNames } from '@/generated/codegen';

const MaybeMaintenanceMode: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const maintenanceModeOn = useMaintenanceModeFlag();
  const isOnline = useIsEffectivelyOnline('3g');
  const { user } = useAuthState();
  const isSuperRoot = !!user?.roles.some(
    (role) => role?.role === RoleNames.SuperRoot
  );

  // Offline users are never blocked — there is no flag to fetch when
  // offline, and blocking would strand them on this screen indefinitely.
  // Reactive: a device that goes offline while this screen is up is let
  // through on the next transition, not on the next full reload.
  if (!isOnline) return <>{children}</>;

  // Superroots must be able to verify the site during maintenance
  // (maintainer decision, 2026-09-14).
  if (maintenanceModeOn && !isSuperRoot)
    return (
      <EmptyLayout>
        <div className="w-4/5 md:w-1/3 min-w-80 max-w-lg m-auto">
          <Card
            style={{
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <CardContent className="flex flex-col items-center">
              <FaRegClock size="36" style={{ marginBottom: '1.5em' }} />
              Bilderit se encuentra realizando mantenimiento.
              <br />
              Por favor vuelva a intentar en algunas horas, y sepa disculpar los
              inconvenientes.
            </CardContent>
          </Card>
        </div>
      </EmptyLayout>
    );

  return <>{children}</>;
};

export default MaybeMaintenanceMode;
